import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@core/store";
import * as GlobalAction from "@core/store/actions/global.action";

import { AdapterUi } from "@core/store/adapters/global.adapter";

@Injectable()
export class DashboardFacade {
  constructor(private store: Store<AppState>) {}

  public setUi(setUi: Array<AdapterUi>): void {
    this.store.dispatch(GlobalAction.uiGlobal({ ui: setUi }));
  }

  public clearStore(): void {
    this.store.dispatch(GlobalAction.clearAll());
  }
}
